import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule
} from "@angular/forms";

@Component({
  selector: "app-text-area",
  templateUrl: "./text-area.component.html",
  imports: [ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextAreaComponent implements OnInit {
  id = input.required<string>();
  text = input<string | undefined>();
  placeholder = input<string | undefined>();
  rows = input<number | undefined>();
  parentForm = input.required<FormGroup<any>>();
  formControlKey = input.required<string>();
  maxLength = input<number | undefined>();
  minLength = input<number | undefined>();

  constructor() {}

  ngOnInit() {}

  get control(): AbstractControl {
    return this.parentForm().get(this.formControlKey());
  }
}
